import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader } from "../components/common";
import BatchInbox from "../components/BatchInbox";

export default function RepBatchesPage() {
  const [q, setQ] = useState("");
  const [showAll, setShowAll] = useState(false);
  const [shown, setShown] = useState(null);
  const reload = () => api.get("/batches", { params: { active: !showAll, rep: q || undefined } }).then((r) => setShown(r.data));
  useEffect(() => {
    const t = setTimeout(reload, 250);
    return () => clearTimeout(t);
  }, [q, showAll]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="space-y-6" data-testid="rep-batches-page">
      <PageHeader title="Rep batches" sub="Every rep's lead batches. Revoke all or some unfunded leads back into the pool; the unsent Entrance campaign is deleted and the rep's limit is restored. Campaigns already texting can't be revoked." />
      <div className="flex flex-wrap items-center gap-3">
        <input className="fld w-64" placeholder="Filter by rep name" value={q} onChange={(e) => setQ(e.target.value)} data-testid="rep-batches-filter" />
        <label className="text-sm flex items-center gap-2"><input type="checkbox" checked={showAll} onChange={(e) => setShowAll(e.target.checked)} data-testid="rep-batches-show-all" />Include expired</label>
      </div>
      {shown && <BatchInbox batches={shown} reload={reload} showRep retract="admin" />}
    </div>
  );
}
